var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"tw-capitalize tw-shadow",class:[
        _vm.mode ? 'tw-text-white' : 'tw-text-black',
        _vm.color
    ],attrs:{"loading":_vm.loading,"disabled":_vm.loading,"rounded":"","block":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }